import * as React from 'react';
import { Redirect } from 'react-router';
import { Skill } from '../../model/skill';
import { withSnapshot, WithSnapshot } from '../../context/snapshotContext';
import { getSkill } from '../../api';
import { Loading } from '../Loading/Loading';
import { routes } from '../../lib/routes';
import { SkillPage } from './SkillPage';
import { isIframe } from '../../utils';
import { tycoon } from '../../utils/messages';

interface Props {
    skillId: string;
}

interface State {
    skill?: Skill;
    isFetching: boolean;
}

type CombinedProps = Props & WithSnapshot;

class SkillPageContainer extends React.Component<CombinedProps, State> {
    public state: State = {
        isFetching: false,
    };
    public static getDerivedStateFromProps = (props: CombinedProps, state: State): State => {
        const { snapshot, skillId } = props;
        const { skills } = snapshot;

        let skill: Skill | undefined = skills.find(({ id }) => id === skillId);

        if (!skill && __appConfig.user.isAdmin) {
            if (state.skill && state.skill.id === skillId) {
                skill = state.skill;
            }

            return {
                skill,
                isFetching: !skill,
            };
        }

        if (!skill && isIframe()) {
            tycoon.sendChatNotFound(skillId);
        }

        return {
            skill,
            isFetching: false,
        };
    };

    public componentDidMount = async () => {
        if (this.state.isFetching) {
            await this.fetchSkill();
        }
    };

    public render() {
        const { skill, isFetching } = this.state;

        if (isFetching) {
            return <Loading centered />;
        }

        if (!skill) {
            return <Redirect to={routes.app.root} />;
        }

        return <SkillPage skill={skill} />;
    }

    private fetchSkill = async () => {
        if (this.state.skill || !__appConfig.user.isAdmin) {
            return;
        }

        let skill;

        try {
            skill = await getSkill(this.props.skillId);
        } catch (err) {
            console.error(err);
        } finally {
            this.setState({ skill, isFetching: false });
        }
    };
}

export default withSnapshot(SkillPageContainer);
